import { render } from "./TraceShow.vue?vue&type=template&id=0607210e&scoped=true"
import script from "./TraceShow.vue?vue&type=script&lang=js"
export * from "./TraceShow.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0607210e"]])

export default __exports__